
export class Contact {
    id:number;
    value:string;
    id_type:number;
    //type:Type;
    note:string
}